import React from 'react';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@mui/material';

const SemanticModelDeleteDialog = ({
  open,
  onClose,
  onConfirm,
  record,
  isDeleting = false,
  isCheckingUsage = false,
  usedByWorkspaces = [],
  usageError = ''
}) => {
  const modelName = record?.name || record?.semantic_model_id;
  const isInUse = usedByWorkspaces.length > 0;

  return (
    <Dialog
      open={open}
      onClose={isDeleting ? undefined : onClose}
      fullWidth
      maxWidth="xs"
      PaperProps={{
        sx: {
          bgcolor: 'var(--wb-bg-panel)',
          color: 'var(--wb-text-strong)',
          borderRadius: 2
        }
      }}
    >
      <DialogTitle sx={{ borderBottom: '1px solid var(--wb-overlay-10)' }}>
        {isInUse ? 'No se puede eliminar el modelo' : 'Confirmar eliminación lógica'}
      </DialogTitle>
      <DialogContent sx={{ '&&': { pt: 3 } }}>
        {isCheckingUsage ? (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <CircularProgress size={18} sx={{ color: 'var(--wb-accent)' }} />
            <Typography variant="body2" sx={{ color: 'var(--wb-text)' }}>
              Verificando si el modelo está en uso…
            </Typography>
          </Box>
        ) : isInUse ? (
          <>
            <Typography variant="body1" sx={{ color: 'var(--wb-text)' }}>
              El modelo <strong>{modelName}</strong> se usa en{' '}
              {usedByWorkspaces.length === 1 ? 'este espacio de trabajo' : 'estos espacios de trabajo'}:
            </Typography>
            <Box component="ul" sx={{ my: 1.5, pl: 3, color: 'var(--wb-text)' }}>
              {usedByWorkspaces.map((workspace) => (
                <li key={workspace.semantic_workspace_id || workspace.name}>
                  <strong>{workspace.name || workspace.semantic_workspace_id}</strong>
                </li>
              ))}
            </Box>
            <Typography variant="body2" sx={{ color: 'var(--wb-text-soft)' }}>
              Desvincúlalo de {usedByWorkspaces.length === 1 ? 'ese espacio' : 'esos espacios'} antes de eliminarlo.
            </Typography>
          </>
        ) : (
          <>
            <Typography variant="body1" sx={{ color: 'var(--wb-text)' }}>
              ¿Deseas marcar como eliminado el modelo&nbsp;
              <strong>{modelName}</strong>? Podrás revertirlo desde la edición del modelo.
            </Typography>
            {usageError && (
              <Alert severity="warning" sx={{ mt: 2 }}>
                {usageError}
              </Alert>
            )}
          </>
        )}
      </DialogContent>
      <DialogActions sx={{ borderTop: '1px solid var(--wb-overlay-10)' }}>
        <Button onClick={onClose} disabled={isDeleting} sx={{ color: 'var(--wb-muted)' }}>
          {isInUse ? 'Cerrar' : 'Cancelar'}
        </Button>
        {!isInUse && (
          <Button
            color="error"
            variant="contained"
            onClick={onConfirm}
            disabled={isDeleting || isCheckingUsage}
            sx={{
              bgcolor: 'var(--wb-x-bg-ef4444, #ef4444)',
              '&:hover': { bgcolor: 'var(--wb-x-bg-dc2626, #dc2626)' },
              '&.Mui-disabled': { bgcolor: 'var(--wb-overlay-10)', color: 'var(--wb-text-label)' }
            }}
          >
            {isDeleting ? 'Eliminando…' : 'Confirmar'}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default SemanticModelDeleteDialog;
